<div class="classify-dialog">
  <div class="classify-dialog__header">
    <h1 class="classify-dialog__title">Classify Selected Fees</h1>
    <button class="btn-secondary" type="button" (click)="flipAllFees()">Flip All Fees</button>
    <button class="dialog-close" (click)="dialogRef.close()" type="button" aria-label="Close dialog">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="classify-dialog__content" autocomplete="on">
    @if (data?.messageTitle) {
    <h2 class="classify-dialog__message-title">{{data?.messageTitle}}</h2>
    }
    @if (data?.message) {
    <p class="classify-dialog__message">{{ data?.message }}</p>
    }

    <div class="fee-totals-banner">
      @if (data?.statementTotalFees != null) {
      <div class="fee-totals-banner__row">
        <strong>Total Fees Currently On Statement:</strong>
        <span>{{ (data?.statementTotalFees ?? 0) | currency }}</span>
      </div>
      <div class="fee-totals-banner__row">
        <strong>Total Fees After Submitting:</strong>
        <span>{{ (sumOfListedFees + (data?.statementTotalFees ?? 0)) | currency }}</span>
      </div>
      } @else {
      <div class="fee-totals-banner__row">
        <strong>Total Fees Extracted:</strong>
        <span>{{ sumOfListedFees | currency }}</span>
      </div>
      }
    </div>

    <table class="classify-table">
      <thead>
        <tr>
          <th class="classify-table__select-col">
            <mat-checkbox [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()" (change)="masterToggle()"
              [aria-label]="checkboxLabel()" class="classify-checkbox">
            </mat-checkbox>
          </th>
          <th class="classify-table__label-col">Fee</th>
          <th class="classify-table__class-col">Classification</th>
          <th class="classify-table__amount-col">Amount</th>
          <th class="classify-table__flagged-col">Flagged?</th>
          <th class="classify-table__remove-col"></th>
        </tr>
      </thead>
      <tbody>
        @for (pdfText of matTableDataSource.data; track pdfText; let i = $index; let even = $even) {
        <tr [class.classify-table__row--even]="even">
          <td>
            <mat-checkbox [(ngModel)]="pdfText.optionSelected" [ngModelOptions]="{ standalone: true }"
              (click)="$event.stopPropagation()" (change)="selection.toggle(pdfText)"
              [aria-label]="checkboxLabel(pdfText)" class="classify-checkbox">
            </mat-checkbox>
          </td>
          <td>
            @if (pdfText.feeGroup !== feeGroupEnum.INTERCHANGE) {
            <div class="field">
              <label class="field__label">Label</label>
              <input class="field__input" type="text" [(ngModel)]="pdfText.feeLabel"
                [ngModelOptions]="{ standalone: true }" minlength="5" maxlength="100" required>
            </div>
            } @else {
            <div class="field mb-1">
              <label class="field__label">Label</label>
              <input class="field__input" type="text" [(ngModel)]="pdfText.feeLabel"
                [ngModelOptions]="{ standalone: true }" minlength="5" maxlength="100" required>
            </div>
            <div class="field">
              <label class="field__label">Program</label>
              <div class="custom-select" [class.custom-select--open]="openProgramDropdown[i]"
                (click)="openProgramDropdown[i] = !openProgramDropdown[i]">
                <span class="custom-select__value">
                  {{interchangeProgramControl[i].value || 'Select program'}}
                </span>
                <span class="material-symbols-outlined custom-select__arrow">expand_more</span>
                @if (openProgramDropdown[i]) {
                <div class="custom-select__dropdown">
                  @for (program of filteredPrograms[i] | async; track program) {
                  <div class="custom-select__option" (click)="selectProgram(i, program); $event.stopPropagation()">
                    {{program}}
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }
          </td>
          <td>
            <mat-radio-group class="classify-radio-group" [(ngModel)]="pdfText.feeGroup"
              [ngModelOptions]="{ standalone: true }">
              @for (fg of feeGroupingOptions; track fg) {
              <mat-radio-button [value]="fg.name" class="classify-radio" color="primary">
                {{fg.abbrev}}
              </mat-radio-button>
              }
            </mat-radio-group>
          </td>
          <td>
            <div class="field field--amount">
              <span class="field__prefix">$</span>
              <input class="field__input field__input--prefixed" type="number" [(ngModel)]="pdfText.feeAmount"
                [ngModelOptions]="{ standalone: true }" title="Change or replace the extracted fee amount">
            </div>
          </td>
          <td>
            @if (pdfText.feeGroup === feeGroupEnum.NON_NEGOTIABLE || pdfText.feeGroup === feeGroupEnum.INTERCHANGE) {
            <mat-checkbox [(ngModel)]="pdfText.isFlagged" [ngModelOptions]="{ standalone: true }"
              class="classify-checkbox">
            </mat-checkbox>
            }
          </td>
          <td>
            <button class="fee-item__remove" type="button" (click)="removeFee(pdfText)"
              aria-label="Remove this fee from the list">
              <i class="fas fa-times-circle"></i>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="classify-dialog__actions">
    @if (isAnyOptionsSelected()) {
    <div class="field classify-dialog__bulk-select">
      <label class="field__label">Select an option</label>
      <div class="custom-select" [class.custom-select--open]="bulkDropdownOpen"
        (click)="bulkDropdownOpen = !bulkDropdownOpen">
        <span class="custom-select__value">{{ bulkOptionLabel(selectedOption) }}</span>
        <span class="material-symbols-outlined custom-select__arrow">expand_more</span>
        @if (bulkDropdownOpen) {
        <div class="custom-select__dropdown">
          <div class="custom-select__option" (click)="chooseBulkOption(null); $event.stopPropagation()">None</div>
          <div class="custom-select__option" (click)="chooseBulkOption('removeRows'); $event.stopPropagation()">Remove
            row(s)</div>
          <div class="custom-select__option" (click)="chooseBulkOption('Addtnl'); $event.stopPropagation()">"Addtnl" Fee
            Classification</div>
          <div class="custom-select__option" (click)="chooseBulkOption('Assess'); $event.stopPropagation()">"Assess" Fee
            Classification</div>
          <div class="custom-select__option" (click)="chooseBulkOption('NonNeg'); $event.stopPropagation()">"NonNeg" Fee
            Classification</div>
          <div class="custom-select__option" (click)="chooseBulkOption('Intchg'); $event.stopPropagation()">"Intchg" Fee
            Classification</div>
        </div>
        }
      </div>
    </div>
    }
    <div class="classify-dialog__actions-spacer"></div>
    <button class="btn-secondary" type="button" (click)="dialogRef.close()">Cancel</button>
    <button class="btn-primary" type="button" [disabled]="isEmptyRecords()" (click)="processFeeClassifications()">Submit
      ALL</button>
  </div>
</div>